<template>
  <div class="container">
    <div class="row">
      <div class="evaluate">
        <h1 class="title">{{(company&&company._id?(evaluate.alias?evaluate.alias:evaluate.name):evaluate.name)+(company&&company._id?('-'+company.name):'')}}</h1>
        <div class="infos">
          <span class="item">本次测试共
            <span class="num">{{evaluate.questions_num}}</span>题</span>
          <span class="item">,剩余
            <span class="num">{{questions.length - index}}</span>题</span>
          <span class="item right" v-if="evaluate.duration !== -1 ">
            倒计时:
            <span class="num">{{ duration_text }}</span>
          </span>
        </div>
        <div class="desc" v-if="evaluate.show_type === 2" v-html="evaluate.desc"></div>
        <div v-show="questions.length === 0 || loading === 1">
          <div class="row">
            <div class="col-xs-12 text-center" style="height:300px;line-height:300px;">
              {{load_msg}}
            </div>
          </div>
        </div>
        <div v-show="questions.length > 0 && loading === 0">
          <div v-for="(question,qindex) in questions" :key="question._id" :class="{'que-lock':question.locked,'que-loading':question.loading ,'current': question._id === que._id}" :id="'que-'+question._id">
            <div class="question" v-show="(evaluate.show_type === 2) || (question._id === que._id)">
              <div class="title clearfix">
                <div class="index">Q{{(evaluate.questions_num - questions.length)+qindex+1}}:</div>
                <div class="body">
                  <div v-if="question.title.length > 0">{{question.title}}</div>
                  <div v-show="question.title_duration != 0" v-html="question.title_rich"></div>
                </div>
              </div>
              <div class="options" v-show="question.title_duration <= 0">
                <div v-if="question.category === 1 || question.category === 2 || question.category === 5 ">
                  <ul v-bind:class="{'list':question.option_layout_type === 1,'grid':question.option_layout_type === 2,'list-without-identifier':question.option_layout_type === 3,'grid-without-identifier':question.option_layout_type === 4}">
                    <li class="option" v-for="(option,oindex) in question.options" @click="optionSelected(option,question)" :class="{'selected':  option.is_selected == 1}" :key="option._id">
                      <span class="identifier">{{(oindex+97)|toChar|upper}}</span>
                      <span v-if="option.category === 1">{{option.content}}</span>
                      <span v-if="option.category === 2">
                        <img :src="option.image.url" :alt="option.image.name">
                      </span>
                    </li>
                  </ul>
                </div>
                <!-- 对偶选择题  -->
                <div class="duality" v-if="question.category === 3">
                  <div class="option col-sm-5" @click="optionSelected(question.options[0],question)" :class="{'selected': question.options[0].is_selected == 1}">
                    <div class="body red">
                      <span v-if="question.options[0].category === 1">{{question.options[0].content}}</span>
                      <span v-if="question.options[0].category === 2">
                        <img :src="question.options[0].image.url" :alt="question.options[0].image.name">
                      </span>
                    </div>
                  </div>
                  <div class="option col-md-2">
                    <img class="vs" src="/assets/images/vs.gif" alt="">
                  </div>
                  <div class="option col-sm-5" @click="optionSelected(question.options[1],question)" :class="{'selected':  question.options[1].is_selected == 1}">
                    <div class="body blue">
                      <span v-if="question.options[1].category === 1">{{question.options[1].content}}</span>
                      <span v-if="question.options[1].category === 2">
                        <img :src="question.options[1].image.url" :alt="question.options[1].image.name">
                      </span>
                    </div>
                  </div>
                </div>
                <!-- 对偶选择题  -->
              </div>
              <div class="b-b b-dashed m-t-b-sm"></div>
            </div>
          </div>
        </div>
        <div class="actions m-t-sm">
          <div class="row">
            <div class="col-xs-12" v-if="resume_select_show === 1">
              <div class="row">
                <label for="user-resume-selects">选择简历(可选):</label>
                <select class="select input-sm" id="user-resume-selects" v-model="evaluate_result.resume_id" @change="resumeChange()">
                  <option value="">选择已有简历</option>
                  <option :value="resume._id" v-for="resume in resumes" :key="resume._id">{{resume.name}}-{{resume.post_name}}</option>
                </select>
                <button type="button" class="btn btn-sm btn-info" :disabled="!evaluate_result.resume_id" @click="previewResume()">
                  <i class="fa fa-search p-r-xs"></i> 预览</button>
                <button type="button" class="btn btn-sm btn-primary" id="resume-upload-btn">
                  <i class="fa fa-cloud-upload p-r-xs"></i>上传</button>
              </div>
              <div class="row" v-show="evaluate_result.resume_name">
                <div class="col-xs-12 p-t-sm">
                  上传简历：
                  <span class="bold">{{evaluate_result.resume_name}}</span>
                </div>
              </div>
            </div>
            <div class="col-xs-12 m-t-sm">
              <button type="button" v-on:click="next" class="btn btn-success" v-if="evaluate.show_type === 1 &&que.option_category !==1 && (index < questions.length - 1)">下一题</button>
              <button type="button" v-on:click="finish" class="btn btn-md btn-success" v-if="evaluate.show_type === 2 || ( evaluate.category ===2 && index === questions.length - 1)" :disabled="is_completed">完成测评</button>
            </div>
          </div>
          <div class="row">
            <h5 class="text-center m-t-b-sm">本次测评由
              <a href="http://www.psych.cas.cn" title="中国科学院心理研究所" alt="中国科学院心理研究所" style="color:#000">中国科学院心理研究所</a> 提供测评技术支持</h5>
          </div>
          <div id="hidden-click-actions" style="display:none;"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import Evaluate from "../../resource/evaluate";
import WebUploader from "webuploader";

export default {
  name: "EvaluateStart",
  data: function() {
    return {
      normal_destroy: 1, // 异常销毁
      que: {
        title_duration: -1
      },
      loading: 1,
      load_msg: "正在生成试卷，请稍后……",
      questions: [],
      view_questions: {},
      view_options: {},
      index: 0,
      timer: {
        // 定时器
        evaluate: null,
        question: null
      },
      company: {},
      que_start_time_unix: 0,
      que_end_time_unix: 0,
      is_completed: false,
      selected_options: [],
      duration: 0,
      evaluate_result: {
        status: 1, // 测评状态
        start_time_unix: 0, // 测评开始时间
        end_time_unix: 0, // 测评结束时间
        user_questions: [], // 测评记录
        resume_id: "", // 简历ID
        resume_url: "", // 简历名称
        resume_name: "" // 简历名称
      },
      resume_select_show: 0,
      resumes: [],
      view_resumes: {},
      evaluate: {},
      code: ""
    };
  },
  computed: {
    // 计算属性
    duration_text: function() {
      let that = this;
      let [min, sec] = [Math.floor(that.duration / 60), that.duration % 60];
      return `${min > 9 ? min : "0" + min}:${sec > 9 ? sec : "0" + sec}`;
    }
  },
  watch: {
    // 监控数据
    que: function(now, pre) {
      let that = this;
      if (that.evaluate.show_type === 1) {
        if (that.timer.question) {
          // 清除定时器
          window.clearTimeout(that.timer.question),
            (that.timer.question = null);
        }
        // 题干定时
        if (pre.title_duration !== -1) {
          if (pre.timer) {
            // 移除定时器
            clearInterval(pre.timer);
            pre.timer = null;
          }
        }
        if (now._id) {
          let imgs = document.querySelectorAll(`#que-${now._id} img`);
          let start = function() {
            that.que_start_time_unix = Date.now(); // 开始答题时间
            if (now.duration !== -1) {
              // 设置定时器
              that.timer.question = setTimeout(() => {
                //
                that.que_end_time_unix = Date.now(); // 答题结束时间
                if (that.selected_options.length === 0) {
                  that.selected_options.push("0".repeat(24)); // 默认选项
                }
                window.clearTimeout(that.timer.question),
                  (that.timer.question = null); // 清除定时器 // 双清
                that.next(2); // 调用下一题
              }, now.duration * 1000);
            }
            if (now.title_duration !== -1) {
              now.timer = setInterval(() => {
                now.title_duration--;
                if (now.title_duration === 0) {
                  if (now.timer) {
                    // 移除定时器
                    clearInterval(now.timer);
                    now.timer = null;
                  }
                }
              }, 1000);
            }
          };
          if (imgs.length === 0) {
            now.loading = false;
            start();
          } else {
            let timer = function() {
              let flag = true;
              for (let img of imgs) {
                if (!img.complete) {
                  flag = false;
                  break;
                }
              }
              if (!flag) {
                setTimeout(timer, 100);
              } else {
                now.loading = false;
                start();
              }
            };
            timer();
          }
        }
      }
    },
    evaluate: function(now, pre) {
      if (now.name !== pre.name) {
        document.title = now.name;
      }
    }
  },
  created: function() {
    let that = this;
    Evaluate.questionnaire({ code: that.$route.params.code }).then(
      res => {
        let data = res.body;
        if (data.code === 0) {
          that.company = data.result.company;
          that.evaluate = data.result.questionnaire;
          that.is_login = data.result.is_login;
          that.type = data.result.category !== "code" ? 1 : 2;
          if (that.type === 1) {
            // 问卷
            that.$router.replace({
              name: "EvaluateShow",
              params: { code: that.$route.params.code }
            });
            return;
          } else {
            if (!data.result.code || data.result.status === 1) {
              that.code = that.$route.params.code;
              that.start(); // 开始测评
            } else {
              //
              that.$router.replace({
                name: "EvaluateShow",
                params: { code: that.$route.params.code }
              });
              return;
            }
          }
          that.is_processing = false;
        } else if (data.code === 4) {
          // 无权限
          that.$router.replace({ name: "EvaluateList" });
        } else {
          // 无权限
          alert(`服务器异常，请稍后再试\n有人要扣工资了~~~~(>_<)~~~~`);
          that.$router.replace({ name: "EvaluateList" });
        }
        that.is_processing = false;
      },
      res => {
        that.is_processing = false;
      }
    );
  },
  mounted: function() {
    // 页面渲染完成后
    let that = this;
    document.title = that.evaluate.name;
  },
  destroyed: function() {
    var that = this;
    window.onbeforeunload = null;
    if (that.normal_destroy !== 2) {
      if (that.timer.question) {
        // 清除定时
        window.clearTimeout(that.timer.question), (that.timer.question = null);
      }
      if (that.timer.evaluate) {
        // 清除定时
        window.clearInterval(that.timer.evaluate), (that.timer.evaluate = null);
      }
    }
  },
  methods: {
    // 处理方法
    next: function(mode) {
      // 模式 1. 正常，2 超时，3.关闭 //
      mode = mode || 1;
      let that = this;
      if (that.index <= that.questions.length - 1) {
        // 合法数据操作
        if (that.que.selected_options.length > 0) {
          // 已选择
          that.que.locked = true;
          if (that.timer.question) {
            // 清除定时
            window.clearTimeout(that.timer.question);
            that.timer.question = null;
          }
          let result = {
            // 添加记录
            question: that.que._id, // 问题
            start_time_unix: that.que_start_time_unix, // 开始答题时间
            end_time_unix: that.que_end_time_unix || Date.now(), // 结束答题时间
            options: that.que.selected_options.join(","),
            selected_options: that.que.selected_options
          };
          // that.evaluate_result.user_questions.push(result)
          Evaluate.record({ code: that.code }, result).then(
            res => {
              let data = res.body;
              if (data.code === 0) {
                setTimeout(() => {
                  if (that.index < that.questions.length - 1) {
                    that.que = that.questions[++that.index];
                  }
                }, 200);
              } else {
                alert(data.msg);
              }
            },
            res => {
              alert(`服务器异常，请稍后再试!!!\n有人要扣钱了~~~~(>_<)~~~~`);
            }
          );
        } else {
          // 未选择
          alert("您还未完成作答，请完成作答后再开始下一题");
        }
      }
    },
    optionSelected: function(option, que) {
      let that = this;
      if (que.option_category === 1) {
        // 设置问题
        que.locked = true;
        que.selected_options = [option._id];
        that.view_options[option._id].is_selected = 1;
        if (that.index === that.questions.length - 1) {
          that.finish();
        } else {
          that.next();
        }
      } else if (que.option_category === 2) {
        let index = que.selected_options.indexOf(option._id);
        if (index >= 0) {
          // 再次点选移除
          que.selected_options.splice(index, 1);
          that.view_options[option._id].is_selected = 0;
          return;
        }
        que.selected_options.push(option._id);
        that.view_options[option._id].is_selected = 1;
      }
    },
    finish: function() {
      // 结束测评
      let that = this;
      that.is_completed = true;
      if (that.company && that.company._id && that.resume_select_show === 0) {
        // 企业问卷
        that.resume_select_show = 1; // 显示 上传简历位置
        that.is_completed = false;
        that.loadResumes();
        that.initUploader();
        return;
      }
      // 暂时取消简历必传限制
      // if (that.company && that.company._id && that.resume_select_show === 1) { // 企业问卷
      //   if (!that.evaluate_result.resume_id && !that.evaluate_result.resume_url) {
      //     that.is_completed = false
      //     alert('请选择要上传的简历');
      //     return
      //   }
      // }
      if (that.evaluate.show_type === 2) {
        // 单页全题
        that.evaluate_result.user_questions.forEach(que => {
          que.options = que.selected_options.join(",");
        });
      }
      if (that.timer.evaluate) {
        // 清除定时器
        window.clearInterval(that.timer.evaluate);
        that.timer.evaluate = null;
      }
      if (that.evaluate_result.status == 1) {
        // 正常提交
        if (that.evaluate.show_type === 1) {
          // 一页一题
          that.next(3); // 保存结果
        }
        that.evaluate_result.status = 2; // 提交状态2
      }
      that.evaluate_result.end_time_unix =
        that.evaluate_result.end_time_unix || Date.now(); // 设置结束时间
      that.$http
        .put(`/api/v1/evaluate/${that.code}/end`, that.evaluate_result)
        .then(
          res => {
            if (res.status === 200) {
              let body = res.body;
              if (body.code === 0) {
                that.normal_destroy = 2; // 正常销毁
                return that.$router.push(`/evaluate/${that.code}/report`);
              } else {
                that.is_completed = false;
                alert(body.msg);
              }
            } else {
              that.is_completed = false;
            }
          },
          res => {
            alert(`服务器异常，请稍后再试\n有人要扣工资了~~~~(>_<)~~~~`);
            that.is_completed = false;
          }
        );
    },
    start: function() {
      let that = this;
      that.$http.put(`/api/v1/evaluate/${that.code}/start`).then(
        res2 => {
          if (res2.status === 200) {
            let data = res2.body;
            if (data.code === 0) {
              let questions = [];
              data.result.forEach(que => {
                que.selected_options = [];
                que.locked = false;
                que.loading = true;
                que.options &&
                  que.options.forEach(option => {
                    option.is_selected = 0;
                    that.view_options[option._id] = option;
                  });
                questions.push(que);
                that.view_questions[que._id] = que;
              });
              that.questions = questions;

              let time_unix = Date.now();
              that.que_start_time_unix = time_unix; // 问题测评开始时间
              that.evaluate_result.start_time_unix = time_unix; // 问卷测评开始时间
              if (questions.length > 0) {
                if (that.evaluate.duration !== -1) {
                  // 开启定时
                  that.duration = that.evaluate.duration;
                  that.timer.evaluate = setInterval(() => {
                    if (that.duration > 0) {
                      that.duration--;
                    } else {
                      // 测评结束
                      if (that.timer.evaluate) {
                        // 清除定时
                        window.clearInterval(that.timer.evaluate);
                        that.timer.evaluate = null;
                      }
                      that.evaluate_result.end_time_unix =
                        that.evaluate_result.end_time_unix || Date.now(); // 设置结束时间
                      that.status = 3; // 超时
                      that.finish(); // finish evaluate
                    }
                  }, 1000);
                }
                setTimeout(() => {
                  that.que = that.questions[0];
                  that.loading = 0;
                }, 200);
              } else {
                that.load_msg =
                  "您在3个月内已经测评完成该测评的所有试题，正在为您自动提交，请稍后";
                that.evaluate_result.status = 2; // 提交状态2
                if (that.company && that.company._id) {
                  // 企业问卷
                  that.index = -1;
                  that.load_msg =
                    "您在3个月内已经测评完成该测评的所有试题，请上传个人简历，完成测评。";
                }
                that.finish();
              }
            } else {
              alert(data.msg);
            }
          } else {
            alert(res2.status);
          }
        },
        res2 => {}
      );
    },
    loadResumes: function() {
      let that = this;
      that.$http.get("/api/v1/resumes/my_resumes", {}, {}).then(
        res => {
          let data = res.body;
          if (data.code === 0) {
            that.resumes = data.result.map(resume => {
              resume.name_text = `${resume.name}-${resume.post_name}-`;
              that.view_resumes[resume._id] = resume;
              return resume;
            });
          } else {
          }
        },
        res => {}
      );
    },
    initUploader: function() {
      let that = this;
      let mimeTypes = [
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.presentationml.presentation",
        "application/vnd.ms-powerpoint",
        "application/octet-stream"
      ];
      setTimeout(() => {
        let uploader = WebUploader.create({
          auto: true,
          server: "/api/upload",
          pick: {
            id: "#resume-upload-btn",
            innerHTML: "",
            multiple: false
          },
          formData: {}
        });
        uploader.on("beforeFileQueued", file => {
          if (mimeTypes.indexOf(file.type) < 0) {
            alert("请上传word,ppt格式简历");
            return false;
          } else if (file.size > 20971520) {
            alert("请选择20M以内文件进行上传");
            return false;
          }
          return true;
        });
        uploader.on("uploadSuccess", (file, res) => {
          if (res.code === 0) {
            that.evaluate_result.resume_name = res.result.filename;
            that.evaluate_result.resume_url = res.result.fileurl;
            that.evaluate_result.resume_id = "";
          } else {
            alert(res.msg);
          }
        });
      }, 100);
    },
    previewResume: function() {
      let that = this;
      let resume = that.view_resumes[that.evaluate_result.resume_id];
      if (resume) {
        let doc = document;
        // let f = doc.querySelector('#hidden-click-actions') //
        let a = doc.createElement("a");
        a.href = resume.is_convert == 1 ? resume.url_convert : resume.url;
        if (resume.is_convert == -1) {
          a.download = resume.name;
        }
        a.target = "_blank";
        let evt = document.createEvent("HTMLEvents");
        evt.initEvent("click", false, false);
        a.dispatchEvent(evt);
      }
    },
    resumeChange: function() {
      let that = this;
      that.evaluate_result.resume_name = "";
      that.evaluate_result.resume_url = "";
    }
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less"></style>


// WEBPACK FOOTER //
// start.vue?f4140564